import { render, staticRenderFns } from "./FuelLevelWarning.vue?vue&type=template&id=63b80b20"
import script from "./FuelLevelWarning.vue?vue&type=script&lang=js"
export * from "./FuelLevelWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports